import { signOut } from 'firebase/auth';
import { forgetDeviceLink } from './deviceLink';

const LOGOUT_GUARD_KEY = 'ecobill_logout_guard';

function setLogoutGuard() {
  try { localStorage.setItem(LOGOUT_GUARD_KEY, '1'); } catch {}
}

export function clearLogoutGuard() {
  try { localStorage.removeItem(LOGOUT_GUARD_KEY); } catch {}
}

export async function logoutSafely(authInstance) {
  setLogoutGuard();
  // Détache l'appareil AVANT le signOut : sinon le prochain scan rouvrirait ce compte
  await forgetDeviceLink();
  // même si le signOut échoue, on conserve le garde pour éviter une reconnexion immédiate
  await signOut(authInstance);
}
